<template lang="pug">
	.editor-control-input-text(:class="{'change-process': changedValue !== null, [theme]: true}")
		.input-title(v-if="title" :style="{width: (options.titleWidth || '') + 'px'}") {{title}}
		.control-text
			.number-input
				label
					input.form-control.form-control-sm(:value="getDisplayedValue()" @keyup="changeValueByInput($event.target.value, null, $event, false)" @change="changeValueByInput($event.target.value, null, $event)" @focus="blockUpdate()" @blur="unblockUpdate()" :style="{width: (options.inputWidth || '') + 'px'}")
</template>

<script>

	import Screen 							from './../../../mixins/screen'

	import { Elements }						from './../../../services/Elements'

	export default {
		name: 'InputAngle',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Selected Screen Switched",
				"Selected Element Switched"
			],
			events: {
				"Selected Element Changed": function() {

					this.update();

				}
			}
		},
		components: {},
		props: ["title", "default", "value", "options", "theme"],
		data() {

			this.element = null;

			return {
				showed: true,
				changedValue: null
			};

		},
		methods: {
			collectData() {

				this.element = Elements.SelectedElement;

			},
			getDisplayedValue() {

				let value = this.changedValue !== null ? this.changedValue : this.value;

				if (value === undefined) value = this.default;

				return value;

			},
			getValue() {

				let value = null;

				if (this.changedValue !== null) value = this.changedValue;
				else if (this.value !== undefined) value = this.value;
				else value = this.default;

				value = this.restoreValueType(value);

				return value;

			},
			setValue(value, fixAccuracy = true, forceUpdate = false) {

				this.changedValue = value;

				if (forceUpdate) this.$forceUpdate();
				else this.update();

				this.sendValue(this.getValue());

			},
			restoreValueType(value) {

				return value + '';

			},
			sendValue(value) {

				this.$emit('input', value);

				clearTimeout(this.sendTimeout);
				this.sendTimeout = setTimeout(() => {

					this.$emit('change', value);

					this.changedValue = null;

					this.update();

				}, 500);

			},
			isDisplayedValueChanged() {

				if (this.changedValue === null) return false;

				let changedValue = this.restoreValueType(this.changedValue),
					baseValue = this.restoreValueType(this.value);

				return JSON.stringify(changedValue) !== JSON.stringify(baseValue);

			},
			changeValueByInput(value, e = null, isSave = true) {

				if (!e || (e.keyCode !== 38 && e.keyCode !== 40)) {

					if (this.changedValue === null) this.changedValue = (this.value !== undefined && this.value !== null) ? this.value : this.default;

					this.changedValue = value;

					if (isSave) this.setValue(this.changedValue, false);


				}

			},
			blockUpdate() {

				// Запрещаем апдейт компонента пока фокус стоит в поле ввода информации
				this.updateBlocked = true;

			},
			unblockUpdate() {

				this.updateBlocked = false;

				// Пробуем через таймаут обновить компонент
				// Если updateBlocked к этому моменту всё ещё будет false то компонент обновится и отобразит новые клиентские данные
				// Это делается чтобы заблокировать обновление полей ввода пока пользователь не завершил их ввод
				// Без этого автообновления мешают печатать новые значения в полях типа coords
				clearTimeout(this.updateTimeout);
				this.updateTimeout = setTimeout(() => {

					this.update();

				}, 200);

			}
		}

	}
</script>

<style lang="sass">

	.editor-control-input-text
		color: #f3f4f5
		display: flex
		flex-direction: row
		flex-wrap: nowrap
		min-height: 31px
		align-items: center

		.cursor-container
			position: fixed
			z-index: 2
			left: 0
			top: 0
			width: 100%
			height: 100%
			cursor: move

		.input-title
			display: flex
			justify-content: left
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.control-text
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			justify-content: left

			.number-input
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				border-radius: 0.1rem
				color: rgba(255, 255, 255, 0.87)
				background-color: rgba(255, 255, 255, 0.05)
				border: 1px solid rgba(255, 255, 255, 0.09)
				transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out
				overflow: hidden
				min-width: 60px
				height: 24px

				label
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					margin: 0
					padding: 0

				input
					margin: 0
					width: 58px
					height: 100%
					box-shadow: none
					outline: none !important
					border-radius: 0
					border: none
					background-color: transparent
					padding: 0 3px

	.editor-control-input-angle.dark-medium

		.control-number

			.number-input
				height: 30px
				border: 1px solid #23282c
				border-radius: 0.25rem
				background: #515b65
				transition: none

				&:focus
					outline: none
					box-shadow: none
					background: #515b65
					border: 1px solid rgba(255, 255, 255, 0.3)

				&:hover
					outline: none
					box-shadow: none
					background: #515b65
					border: 1px solid rgba(255, 255, 255, 0.3)

				label


				input
					padding: 0 7px

</style>
